<script>
export default {
  data () {
    return {
      usZipCode: '#####-####'
    }
  }
}
</script>
